import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from '@components';
import { MenuItem } from '@material-ui/core';

const ShowDotsMenu = ({
  canResendInvitation,
  canEdit,
  canBlock,
  canUnblock,
  canDelete,
  handleResendInvitation,
  handleEdit,
  handleBlock,
  handleUnblock,
  handleDelete,
  htmlIdEditItem = 'unidentified-id',
  htmlIdResendInvitationItem = 'unidentified-id',
  htmlIdBlockItem = 'unidentified-id',
  htmlIdUnblockItem = 'unidentified-id',
  htmlIdDeleteItem = 'unidentified-id',
}) => {
  const { t } = useTranslation();
  if (!canResendInvitation && !canEdit && !canBlock && !canUnblock && !canDelete) return null;

  return (
    <Menu icon="ic_menu_dots.svg" data-testid="dots-icon">
      {canResendInvitation && (
        <MenuItem
          id={htmlIdResendInvitationItem}
          onClick={handleResendInvitation}
          data-testid="resend-dot-opt"
        >
          {t('users.actions.resendInvitation')}
        </MenuItem>
      )}
      {canEdit && (
        <MenuItem id={htmlIdEditItem} data-testid="edit-testid" onClick={handleEdit}>
          {t('users.list.edit')}
        </MenuItem>
      )}
      {canBlock && (
        <MenuItem id={htmlIdBlockItem} onClick={handleBlock} data-testid="block-dot-opt">
          {t('users.actions.block')}
        </MenuItem>
      )}
      {canUnblock && (
        <MenuItem id={htmlIdUnblockItem} onClick={handleUnblock} data-testid="unblock-dot-opt">
          {t('users.actions.unblock')}
        </MenuItem>
      )}
      {canDelete && (
        <MenuItem id={htmlIdDeleteItem} onClick={handleDelete} data-testid="delete-dot-opt">
          {t('users.actions.delete')}
        </MenuItem>
      )}
    </Menu>
  );
};

export default ShowDotsMenu;
